export enum FormFields {
  quantity = 'quantity',
  prefix = 'prefix',
}

export type FormValues = {
  [FormFields.quantity]?: number
  [FormFields.prefix]?: string
}
